import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, BoxProps, Button, IconButton, Stack, Typography } from "@mui/material";

const boxSx: BoxProps["sx"] = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  borderRadius: "10px",
  width: "500px",
  zIndex: "1500 !important"
};

interface Props {
  type: "trial";
  onCancel: () => void;
}

const descriptions = {
  trial:
    "You are currently in trial mode with limited access. Contact your Altius representative to upgrade to full access"
};

export const Notice: React.FC<Props> = ({ type, onCancel }) => {
  return (
    <Box sx={boxSx}>
      <Box sx={{ background: "#fff", borderRadius: "10px 10px 0px 0px", padding: "30px 30px 0 30px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid  #DAE0E2", paddingBottom: "5px" }}
        >
          <span>Notice</span>
          <IconButton onClick={onCancel}>
            <CloseIcon className="icon" />
          </IconButton>
        </Stack>
      </Box>
      <Stack alignItems="stretch" sx={{ p: "20px 30px 30px 30px" }}>
        <Typography variant="body1" color="#0A3142">
          {descriptions[type]}
        </Typography>
        <Stack sx={{ mt: "30px" }} direction="row" justifyContent="flex-end" gap="20px">
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
